import { JSX, lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

import { createRouteConfig } from 'modules/common/utils/createRouteConfig';

import { QueryLoading } from './components/QueryLoading';

const ROOT = `/dev/`;
const PLAYGROUND = `${ROOT}playground/`;

export const devRouteConfig = createRouteConfig(
  {
    dev: {
      path: ROOT,
      generatePath: () => ROOT,
    },

    playground: {
      path: PLAYGROUND,
      generatePath: () => PLAYGROUND,
    },
  },
  ROOT,
);

const DevPage = lazy(() =>
  import('./screens/DevPage').then(({ DevPage }) => ({
    default: DevPage,
  })),
);

const TestPlayground = lazy(() =>
  import('./screens/TestPlayground').then(({ TestPlayground }) => ({
    default: TestPlayground,
  })),
);

export function getDevRoutes(): JSX.Element {
  return (
    <>
      <Route
        element={
          <Suspense fallback={<QueryLoading isAbsolute />}>
            <DevPage />
          </Suspense>
        }
        path={devRouteConfig.dev.path}
      />

      <Route
        element={
          <Suspense fallback={<QueryLoading isAbsolute />}>
            <TestPlayground />
          </Suspense>
        }
        path={devRouteConfig.playground.path}
      />
    </>
  );
}
